import { render, staticRenderFns } from "./TxRecord.vue?vue&type=template&id=0c3e83fc&scoped=true&"
import script from "./TxRecord.vue?vue&type=script&lang=js&"
export * from "./TxRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e83fc",
  null
  
)

export default component.exports